import { render, staticRenderFns } from "./firm-lawyer-search.vue?vue&type=template&id=63f2c1b9&scoped=true"
import script from "./firm-lawyer-search.vue?vue&type=script&lang=js"
export * from "./firm-lawyer-search.vue?vue&type=script&lang=js"
import style0 from "./firm-lawyer-search.vue?vue&type=style&index=0&id=63f2c1b9&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f2c1b9",
  null
  
)

export default component.exports